import { render, staticRenderFns } from "./RestoreForm.vue?vue&type=template&id=6d90003c&"
import script from "./RestoreForm.vue?vue&type=script&lang=js&"
export * from "./RestoreForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports